import ErrorPage from './default';
import { ALREADY_CLIENT_ERROR_PAGE_TEXT } from './constants';

function AlreadyPurchaseBaf(props) {
  return (
    <ErrorPage
      {...props}
      title={ALREADY_CLIENT_ERROR_PAGE_TEXT.TITLE}
      iconColor="BLUE"
      iconId="informacion"
      buttonText={ALREADY_CLIENT_ERROR_PAGE_TEXT.BUTTON_TEXT}
      buttonOnClick={ALREADY_CLIENT_ERROR_PAGE_TEXT.BUTTON_ONCLICK}
      description={ALREADY_CLIENT_ERROR_PAGE_TEXT.DESCRIPTION}
      showLink={false}
    />
  );
}
export default AlreadyPurchaseBaf;
